import axios from 'axios';

const del = (url, id) => {
  return axios.delete(`${url}/${id}`);
};

export default del;